module.exports = __webpack_public_path__ + "img/iztcode.dae3c315.jpg";